import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommissionRoutingModule } from './commission-routing.module';
import { CommPlanComponent } from './comm-plan/comm-plan.component';
import { PromoCodesComponent } from './promo-codes/promo-codes.component';
import { ManageAllCodesComponent } from './manage-all-codes/manage-all-codes.component';
import { HomeModule } from '../home/home.module';
import { ReplicatePlanComponent } from './replicate-plan/replicate-plan.component';
import { ViewPlansComponent } from './view-plans/view-plans.component';
import { EditKpiComponent } from './edit-kpi/edit-kpi.component';
import { KpimasterComponent } from './kpimaster/kpimaster.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NotificationModule } from '../notification.module';
import { NotificationService } from '../service/notification.service';
import { MaterialModule } from '../material/material.module';
import { AdjustmentsComponent } from './adjustments/adjustments.component';
import { FeedAdjustmentsComponent } from './feed-adjustments/feed-adjustments.component';
import { KomFeedResultComponent } from './kom-feed-result/kom-feed-result.component';
import { EntFeedResultComponent } from './ent-feed-result/ent-feed-result.component';

import { EditKomfeedComponent } from './edit-komfeed/edit-komfeed.component';

import { EditEntfeedComponent } from './edit-entfeed/edit-entfeed.component';
import { BossCallMappingComponent } from './boss-call-mapping/boss-call-mapping.component';
import { KomCallDataComponent } from './kom-call-data/kom-call-data.component';
import { AddAdjustmentsComponent } from './add-adjustments/add-adjustments.component';
import { MissingDisputesComponent } from './missing-disputes/missing-disputes.component';
import { MobileAdjustmentsComponent } from './mobile-adjustments/mobile-adjustments.component';
import { EditMobilefeedComponent } from './edit-mobilefeed/edit-mobilefeed.component';
import { AddMobilefeedComponent } from './add-mobilefeed/add-mobilefeed.component';
import { MessageCreatorComponent } from './message-creator/message-creator.component';
import { NotificationConfigsComponent } from './notification-configs/notification-configs.component';
import { AngularEditorComponent, AngularEditorModule } from '@kolkov/angular-editor';
import { RntAdjustmentsComponent } from './rnt-adjustments/rnt-adjustments.component';
import { EditRntfeedComponent } from './edit-rntfeed/edit-rntfeed.component';


@NgModule({
  declarations: [KpimasterComponent, CommPlanComponent, PromoCodesComponent, ManageAllCodesComponent, ReplicatePlanComponent, ViewPlansComponent, EditKpiComponent, AdjustmentsComponent, FeedAdjustmentsComponent, KomFeedResultComponent, EntFeedResultComponent, EditKomfeedComponent, EditEntfeedComponent, BossCallMappingComponent, KomCallDataComponent, AddAdjustmentsComponent, MissingDisputesComponent, MobileAdjustmentsComponent, EditMobilefeedComponent, AddMobilefeedComponent, MessageCreatorComponent, NotificationConfigsComponent, RntAdjustmentsComponent, EditRntfeedComponent],
  imports: [
    CommissionRoutingModule,
    HomeModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NotificationModule,
    MaterialModule,
    AngularEditorModule
  ],
  providers: [NotificationService]
})
export class CommissionModule { }
